import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles((theme) => ({
  panel: {
    margin: 50,
    display: "flex",
    flexDirection: "column",
    padding: 30,
  },
  card: {
    marginBottom: 40,
    padding: 30,
  },
  title: {
    display: "flex",
    justifyContent: "center",
    marginBottom: 20,
  },
  titleText: {
    fontSize: 30,
    marginLeft: 20,
  },
  image: {
    display: "flex",
    justifyContent: "center",
  }
}));

export default function Game() {
    const classes = useStyles();

    return (
      <Box color="text.primary" className={classes.panel}>
        <Card className={classes.card}>
          <CardContent>
            <Box className={classes.title}>
              <img src="/imgs/seis.png" width="40px" height="40px"/>
              <Typography className={classes.titleText}>SeisWave</Typography>
            </Box>
            <Typography>
              SeisWave is a not only a pixel art game but also an app aiming to teach geophysics student how to locate epicenter using the data recorded by the stations. In this game, you will start with deploying the stations. In general, three stations can confirm the location of earthquake. Then according to the distance between the source and each station calculated by the different arrival time of P-wave and S-wave, you will locate the epicenter during the game. Are you ready to explore the fantastic underground as a geophysicist ? Let’s enjoy the game!
            </Typography>
          </CardContent>
          <CardActions className={classes.image}>
            <img src="/imgs/seis1.png" width="200px" height="400px"/>
            <img src="/imgs/seis2.png" width="200px" height="400px"/>
            <img src="/imgs/seis3.png" width="200px" height="400px"/>
            <img src="/imgs/seis4.png" width="200px" height="400px"/>
            <img src="/imgs/seis5.png" width="200px" height="400px"/>
            <img src="/imgs/seis6.png" width="200px" height="400px"/>
            <img src="/imgs/seis7.png" width="200px" height="400px"/>
            <img src="/imgs/seis8.png" width="200px" height="400px"/>
          </CardActions>
        </Card>
        <Card className={classes.card}>
          <CardContent>
            <Box className={classes.title}>
              <img src="/imgs/sea.png" width="40px" height="40px"/>
              <Typography className={classes.titleText}>DeepestSea</Typography>
            </Box>
            <Typography>
              DeepestSea is my first pixel art game for iPhone and iPad. It is a SpirteKit game built in Swift 4.1. The graphics in the game are designed and made by myself with Photoshop. I was born in the 1990s, when the family computer (FC) was very popular in China. So I became a super fan of pixel art game. In this game, three different kinds of submarine can be selected by the player, they have different initial HP and weapon. The bomb system is also introduced into this game. During the game, you will meet several kinds of deep sea creatures. Let’s explore the deep blue ocean!
            </Typography>
          </CardContent>
          <CardActions className={classes.image}>
            <img src="/imgs/deepestsea_1.png" width="200px" height="400px"/>
            <img src="/imgs/deepestsea_2.png" width="200px" height="400px"/>
            <img src="/imgs/deepestsea_3.png" width="200px" height="400px"/>
            <img src="/imgs/deepestsea_4.png" width="200px" height="400px"/>
            <img src="/imgs/deepestsea_5.png" width="200px" height="400px"/>
            <img src="/imgs/deepestsea_6.png" width="200px" height="400px"/>
            <img src="/imgs/deepestsea_7.png" width="200px" height="400px"/>
            <img src="/imgs/deepestsea_8.png" width="200px" height="400px"/>
          </CardActions>
        </Card>
        <Card className={classes.card}>
          <CardContent>
            <Box className={classes.title}>
              <img src="/imgs/cat.png" width="40px" height="40px"/>
              <Typography className={classes.titleText}>BackstreetCats</Typography>
            </Box>
            <Typography>
              BackstreetCats is a game for the people who are too busy to spend  a lot of time on the phone games. The only thing you need to do is to leave the food (fish, soup, sushi, and pudding) along the backstreet. After two hours, there will be a cat attracted by the delicious food. After you make friend with it, you will obtain a random food automatically. In this game, different food will attract different cat. Let’s feed the lovely kitten and enjoy the happy time with them!
            </Typography>
          </CardContent>
          <CardActions className={classes.image}>
            <img src="/imgs/cat1.png" width="200px" height="400px"/>
            <img src="/imgs/cat2.png" width="200px" height="400px"/>
            <img src="/imgs/cat3.png" width="200px" height="400px"/>
            <img src="/imgs/cat4.png" width="200px" height="400px"/>
            <img src="/imgs/cat5.png" width="200px" height="400px"/>
            <img src="/imgs/cat6.png" width="200px" height="400px"/>
            <img src="/imgs/cat7.png" width="200px" height="400px"/>
            <img src="/imgs/cat8.png" width="200px" height="400px"/>
          </CardActions>
        </Card>
      </Box>
    );
}